<template>
  <div class="guide ">
    <div class="container">
      <div class="mine-title">{{ $t('route.faq') }}</div>
      <div class="content">
        <a-collapse :bordered="false">
          <template #expandIcon="props">
            <a-icon type="caret-right" :rotate="props.isActive ? 90 : 0" />
          </template>
          <a-collapse-panel v-for="item in list" :key="item.id" :header="item.title" class="collapse-panel">
            <div class="html-text" v-html="item.content"></div>
          </a-collapse-panel>
        </a-collapse>
      </div>
    </div>
  </div>
</template>
<script>
import { Collapse } from 'ant-design-vue'
import {GetGuideListAPI} from '../api/api'
export default {
  name: 'Guide',
  components:{
    [Collapse.name]:Collapse,
    [Collapse.Panel.name]:Collapse.Panel
  },
  data() {
    return {
      customStyle:
        'background: #f7f7f7;border-radius: 4px;margin-bottom: 24px;border: 0;overflow: hidden',
      activeName: '1',
      list: []
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init(){
      const { data:{list} } = await GetGuideListAPI()
      this.list = list.map(item => ({
        ...item,
        content: item.content
          .replace(/width=*?/s, 'width="100%"')
          .replace(/height=*?/s, 'height="auto"')
      }));
    }
  },
}
</script>
<style lang="scss" scoped>
.guide {
  min-height: 80vh;
  padding: 20px 0;
  .content {
    margin-top: 20px;
    /deep/ .ant-collapse-borderless{
      background-color: transparent;
    }
    .collapse-panel{
      border: 0;
      overflow: hidden;
      margin-bottom: 20px;
      border-radius: 4px;
      background: #f7f7f7;
    }
    .html-text {
      color: #666666!important;
      /deep/img {
        width: 100% !important;
        height: auto !important;
      }
      /deep/ p{
        line-height: 2;
        margin-bottom: 0;
        span{
          color: #666666!important;
          font-size: 14px !important;
          font-family: "SourceHanSans",sans-serif !important;
        }
      }
    }
  }
}
</style>